
import { Component, OnInit } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseApiService } from '../../Services/base-api.service';
import { AuthService } from '../../Services/auth.service';
import { BaseComponent } from '../../Base/base/base.component';
import { takeUntil, finalize } from 'rxjs';

@Component({
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./confirm-email.component.css'],standalone:false
})
export class ConfirmEmailComponent extends BaseComponent implements OnInit {
  Email!:string
  loading:boolean=false;
  showOtp:boolean=false;
  userForm!: FormGroup;
  constructor(
    private api:BaseApiService,
    private router: Router,
    private auth:AuthService,private http:HttpClient,private messageService :MessageService,private formBuilder:FormBuilder,){
    super();
    this.Email=this.auth.getLoggedEmail();
   }


   seondconfirmEmail(){
    this.loading=true
    let Email=this.Email;
    this.api.create("Auth/SendComfirmEmail",{Email})
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      })
    )
    .subscribe
    (
      {
          next:(response)=>{
            this.messageService.add({ severity: 'success', summary: 'Success', detail: response.message });
            this.loading=false;
            this.showOtp=true;
          },
          error:(
            error
          )=>{
            this.loading=false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
          }
      }
    )
   }
   
   confirmEmail(){
    if (this.userForm.valid) {
      this.loading=true
      const formdata=this.userForm.value;
      this.api.create("Auth/ComfirmEmail",formdata)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe
      (
        {
          next: (response)=>{
            this.api.RefreshToken();
            this.messageService.add({ severity: 'success', summary: 'Success', detail: response.message });
            this.loading=false;
          },
          error:(
            error
          )=>{
  
            this.loading=false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
          }
        }
      )
    }

   }
   otpValidator(control: AbstractControl): ValidationErrors | null {
    const otp = control.value;
    if (otp === null || otp === '') {
      return null;
    }
    if (!/^\d+$/.test(otp)) {
      return { notNumber: true };
    }
    const otpValue = +otp; // Convert to number
    if (otpValue <= 0 || otpValue >= 100000000) {
      return { invalidRange: true };
    }
    return null; // Validation passed
   }
   initilizaform(){
    this.userForm = this.formBuilder.group(
      {
          email:[this.Email, [Validators.required]],
          otp: ['', [Validators.required, this.otpValidator]],
      }
    );
  }
  ngOnInit(): void {
   this.initilizaform();
  }
}
